export default __webpack_public_path__ + "static/smi-9f7c756c557bfa90dc62df388eafc6ea.webp";